import GoogleIcon from "@/assets/icons/googleIcon";
import { Button } from "@/components/ui/button";
import { BASE_URL } from "@/constants";
import { useRouter } from "next/navigation";
import React from "react";

const GoogleButton = () => {
  const router = useRouter();
  const handleGoogle = () => {
    router.push(`${BASE_URL}/auth/google`);
  };
  return (
    <>
      <div className="flex items-center gap-5 my-4">
        <div className="w-full h-[1px] bg-white"></div>
        <div className="text-sm text-white flex-shrink-0">
          Atau login dengan
        </div>
        <div className="w-full h-[1px] bg-white"></div>
      </div>
      <div className="flex justify-center">
        <Button
          onClick={handleGoogle}
          type="button"
          className="py-3 rounded-full px-10 mx-auto my-1 w-72 bg-white hover:bg-slate-100 text-primary-700"
        >
          <div className="">
            <GoogleIcon />
          </div>
          <div className="font-medium text-primary-700">
            Masuk dengan Google
          </div>
        </Button>
      </div>
    </>
  );
};

export default GoogleButton;
